import {useLayoutEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { MODELS } from '../../../Apis/Models';
import { TABLES } from '../../../Apis/Tables';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {VIEW_TYPE} from "../../../enums/ViewType";
import {DeleteItemsApi} from "../../../reduxToolkit/Commons/CommonsApi";
import {permissionObj} from "../../../Helpers/permission";
import {TABS_CARD_DESIGNER} from "../Model/Model";
import {errorMsg} from "../../../Apis/functions";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: FullStack
 */
const CardDesignerPanelApp = () => {
    const [activeStep, setActiveStep] = useState(null);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [view, setView] = useState(VIEW_TYPE.GRID.name);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [option, setOption] = useState(`${TABLES.TEMPLATE}`);
    const [moduleId, setModuleId] = useState(`${MODELS.Template}`);
    const [selectedList, setSelectedList] = useState([]);
    const [addResourceShow, setAddResourceShow] = useState(false);
    const [modified, setModified] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [bodyForExport, setBodyForExport] = useState(null);
    const [steps, setSteps] = useState([]);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [simpleSearch, setSimpleSearch] = useState(false);

    useLayoutEffect(() => {
        let activeTab = null;
        const stepConfig = [
            { tab: TABS_CARD_DESIGNER.TEMPLATES.TRANS, perm: [permissionObj?.WEB_CARD_DESIGNER_READ], index:TABS_CARD_DESIGNER.TEMPLATES.INDEX },//Change to invitation
            { tab: TABS_CARD_DESIGNER.RESOURCES.TRANS, perm: [permissionObj?.WEB_RESOURCES_READ], index:TABS_CARD_DESIGNER.RESOURCES.INDEX }
        ];

        const auxStep = stepConfig.reduce((acc, { tab, perm, index }) => {
            const hasPermission = DEV || perm.some(p => permission?.includes(p));
            if (hasPermission) {
                acc.push({label:t(tab), index:index});
                if(activeTab === null) activeTab = index;
            }
            return acc;
        }, []);

        setSteps(auxStep);

        if(activeTab !== null) handleStepChange(activeTab);
    }, [t, permission]);

    /**
     * Handles changing the active step.
     * Resets the selected items list when the step changes.
     *
     * @param {number} step - The index of the step to activate.
     */
    const handleStepChange = (step) => {
        setActiveStep(step);
        setSelectedList([]);
        setSearchElement('');
        setIsAllChecked(false);
        setSearch(false);
        switch (step) {
            case TABS_CARD_DESIGNER.TEMPLATES.INDEX:
                setModuleId(null);
                setOption(TABLES.TEMPLATE);
                break;
            case TABS_CARD_DESIGNER.RESOURCES.INDEX:
                setModuleId(MODELS.Resource);
                setOption(TABLES.RESOURCES);
                break;
        }
    };

    const permissionButtons = (list) => {
        const permissionRequired = list[activeStep];

        if (!permissionRequired) {
            return false;
        }
        return DEV || permission?.includes(permissionRequired);
    };

    const deleteSelected = (deleteItem) => {
        const body = deleteItem;
        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName: option, body })).then(({ payload: { data: { success, code } } }) => {
                    if (success === true) {
                        setShowDeleteModal(false);
                        setSelectedList([]);
                        setIsAllChecked(false);
                        setModified(true);
                    }else
                        errorMsg(code);
                },
            );
        }
    };

    return {
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        view,
        option,
        DEV,
        permission,
        navigate,
        addResourceShow,
        setAddResourceShow,
        selectedList,
        setSelectedList,
        showDeleteModal,
        setShowDeleteModal,
        modified,
        setModified,
        setSearch,
        searchElement,
        setSearchElement,
        isAllChecked,
        setIsAllChecked,
        deleteSelected,
        setBodyForExport,
        simpleSearch,
        setSimpleSearch,
        permissionButtons

    };
};
export default CardDesignerPanelApp;
